import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck, Clock, Heart, ArrowRight, Phone, MessageCircle, FileText } from 'lucide-react';
import { heroData, contactInfo } from '../mockData';

const About = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="page-about">
      {/* Page Hero */}
      <div className="page-hero">
        <div className="container">
          <h1 className="page-hero-title">Hakkımızda</h1>
          <p className="page-hero-subtitle">
            Erzurum'da güvenli taşımacılığın adresi
          </p>
        </div>
      </div>

      {/* Story Section */}
      <section className="section">
        <div className="container">
          <div className="about-story">
            <div className="about-story-content">
              <h2>Hikayemiz</h2>
              <p>
                Vizyon Turizm olarak Erzurum'da okul servisi ve personel taşımacılığı alanında 
                güvenilir hizmet sunmaktayız. Kurulduğumuz günden bu yana müşteri memnuniyetini 
                en üst düzeyde tutarak, ailelerin ve kurumların güvenini kazandık.
              </p>
              <p>
                Deneyimli şoför kadromuz, düzenli bakımı yapılan modern araç filomuz ve 
                disiplinli hizmet anlayışımızla Erzurum'un zorlu kış şartlarında bile 
                kesintisiz taşımacılık hizmeti veriyoruz.
              </p>
              <Link to="/iletisim" className="btn btn-primary">
                Bizimle İletişime Geçin
                <ArrowRight size={18} />
              </Link>
            </div>
            <div className="about-story-image">
              <img src={heroData.image} alt="Vizyon Turizm" />
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="section" style={{ background: 'var(--gray-50)' }}>
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Misyon & Vizyon</h2>
          </div>
          
          <div className="mv-grid">
            <div className="mv-card">
              <h3>Misyonumuz</h3>
              <p>
                Öğrenci ve personel taşımacılığında güvenli, zamanında ve konforlu hizmet 
                sunarak ailelerin ve kurumların güvenini kazanmak. Her yolculukta kalite 
                ve disiplin anlayışıyla müşteri memnuniyetini en üst düzeyde tutmak.
              </p>
            </div>
            <div className="mv-card">
              <h3>Vizyonumuz</h3>
              <p>
                Erzurum ve çevresinde taşımacılık sektöründe referans gösterilen, 
                güvenilirliği ve kalitesiyle tanınan lider firma olmak. Modern araç 
                filomuz ve profesyonel kadromuzla sektörde standartları belirlemek.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Değerlerimiz</h2>
          </div>
          
          <div className="values-grid">
            <div className="value-card">
              <div className="value-icon">
                <ShieldCheck size={28} />
              </div>
              <h3>Güven</h3>
              <p>Çocuklarınızı ve personelinizi gönül rahatlığıyla emanet edin.</p>
            </div>
            <div className="value-card">
              <div className="value-icon">
                <Clock size={28} />
              </div>
              <h3>Disiplin</h3>
              <p>Zamanında ve düzenli hizmet anlayışımızla kesintisiz taşımacılık.</p>
            </div>
            <div className="value-card">
              <div className="value-icon">
                <Heart size={28} />
              </div>
              <h3>Sorumluluk</h3>
              <p>Her yolcumuza karşı tam sorumluluk bilinci ile hareket ediyoruz.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Process */}
      <section className="section process-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Nasıl Çalışıyoruz?</h2>
          </div>
          
          <div className="process-grid">
            <div className="process-step">
              <div className="process-number">1</div>
              <h3>İletişime Geçin</h3>
              <p>WhatsApp veya telefon ile bize ulaşın, ihtiyaçlarınızı dinleyelim.</p>
            </div>
            <div className="process-step">
              <div className="process-number">2</div>
              <h3>Güzergâh Planlama</h3>
              <p>Size özel güzergâh planlaması yaparak en uygun çözümü sunalım.</p>
            </div>
            <div className="process-step">
              <div className="process-number">3</div>
              <h3>Hizmet Başlangıcı</h3>
              <p>Anlaşma sonrası güvenli ve düzenli taşımacılık hizmetine başlayalım.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta-section">
        <div className="container">
          <h2>Hızlı Teklif Alın</h2>
          <p>Size özel fiyat teklifi için hemen iletişime geçin.</p>
          <a 
            href="https://wa.me/905411492525" 
            className="btn btn-white"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
            </svg>
            WhatsApp ile Teklif Al
          </a>
        </div>
      </section>
    </div>
  );
};

export default About;
